import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ element: Component, roles, ...rest }) => {
  const { isAuthenticated, loading, user } = useSelector((state) => state.userLoaded);
  const location = useLocation();

  // Check if token exists in local storage
  const token = localStorage.getItem('token');

  // If loading, return a loading indicator (optional)
  if (loading) return <div>Loading...</div>;

  // If token exists or user is authenticated, check roles
  if (token || isAuthenticated) {
    // If roles are specified, check if the user's role is allowed
    if (roles && roles.indexOf(user?.role) === -1) {
      return <Navigate to="/" />;
    }
    return <Component {...rest} />;
  }

  // Otherwise, redirect to login page
  return <Navigate to="/login" state={{ from: location }} />;
};

export default PrivateRoute;